module.exports = __webpack_public_path__ + "static/media/Tawuniya-Regular.d876b120.otf";